import * as React from "react";

import { IValidation, TextAreaFieldSchema } from "@cak-legacy/generation-core";
import { TFunction } from "@cak-legacy/i18n-iprox";

import { IsRequiredValidationFactory } from "../utils/ValidationFactories";

export interface ITextAreaFieldOptions {
  translationKey: string;
  isRequired: boolean;
  validations?: IValidation[];
  disabled?: boolean;
  hasCustomOverview?: boolean;
}

export const getTextAreaField = (options: ITextAreaFieldOptions, t: TFunction): TextAreaFieldSchema => {
  return {
    type: "textArea",
    label: t(options.translationKey),
    validate: [
      ...(options.isRequired ? [IsRequiredValidationFactory()] : []),
      ...(options.validations || [])
    ],
    ui: {
      formGroupfullWidth: true,
      flexDirection: "column"
    },
    disabled: options.disabled
  };
};
